import TooltipAble from './tooltip-able.vue';
export default TooltipAble;
